import axios from 'axios';
import { ApiResponse, zps_wp } from '../zps';

export type IProduct = {
  entid: number;
  name: string;
  price: number;
  productid: string;
};

export interface IProductRequest {
  name: string;
  price: number;
  productid: string;
}

export interface IProductResponse extends ApiResponse {
  list: IProduct[];
  type: string;
  totalRows?: number;
}

export const fetchProductsList = (productid?: number): Promise<IProductResponse> => {
  const url = productid ? `${zps_wp}/api/product?productid=${productid}` : `${zps_wp}/api/product`;
  return axios.get<IProductResponse>(url).then(res => res.data);
};

export const fetchProductDetails = (productid: number): Promise<IProductResponse> => {
  const url = `${zps_wp}/api/product?productid=${productid}`;
  return axios.get<IProductResponse>(url).then(res => res.data);
};

export const addProductDetails = (request: IProductRequest, controller: AbortController): Promise<ApiResponse> => {
  const url = `${zps_wp}/api/product`;
  return axios.post<ApiResponse>(url, request, { signal: controller.signal }).then(res => res.data);
};

export const updateProductDetails = (request: IProductRequest, controller: AbortController): Promise<ApiResponse> => {
  const url = `${zps_wp}/api/product`;
  return axios.put<ApiResponse>(url, request, { signal: controller.signal }).then(res => res.data);
};

export const deleteProduct = (entid: number, productid: string): Promise<ApiResponse> => {
  const url = `${zps_wp}/api/product?entid=${entid}&productid=${productid}`;
  return axios.delete<ApiResponse>(url).then(res => res.data);
};
